import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"
import dayjs from "dayjs"

import {
	getInsuranceType,
	getInsuredAmountCurrency,
	formatDate
} from "./helpers"

const header = [
	[
		"A/C Executive",
		"Expirary Date",
		"Insurance Type",
		"Policy No",
		"Customer",
		"Currency",
		"Insured Amount",
		"Net Premium",
		"Period From",
		"Period To",
		"Quotation Number"
	]
]

/****************** Helper Functions ******************/
const getPolicyOfferNumber = (issuerNumber, payload) => {
	const matchedProposal = payload?.cases?.list
		?.find(item =>
			item?.proposals?.find(proposal =>
				proposal?.policies?.find(
					policy => policy?.issuerNumber === issuerNumber
				)
			)
		)
		?.proposals?.find(proposal =>
			proposal?.policies?.find(policy => policy?.issuerNumber === issuerNumber)
		)
	const index = matchedProposal?.policies?.findIndex(item => item.issuerNumber)
	return matchedProposal?.basket?.[index]?.offerNumber
}

/****************** Define Rows ******************/
const rows = payload => {
	let output = []
	let salesmanGroup = {}

	payload
		?.reverse()
		// filter policies with renewedFrom
		?.filter(policy => policy?.proposal?.renewalHistory?.renewedFrom !== null)
		// create an object `salesmanGroup` and group all policies into seperate arrays by commission split remark
		?.map(policy => {
			let type = policy?.commissionSplitRules?.find(
				item => item.remark === "salesman"
			)?.entity?.name

			if (!type) return

			if (!Object.keys(salesmanGroup).includes(type)) {
				salesmanGroup[type] = []
			}
			salesmanGroup[type].push(policy)
		})

	console.log(salesmanGroup)

	Object.keys(salesmanGroup)?.map((item, index) => {
		const policies = Object.values(salesmanGroup)[index]
		const salesman = policies?.[0]?.commissionSplitRules?.find(
			item => item.remark === "salesman"
		)
		output.push(
			...policies.map(policy => [
				`${salesman?.entity?.internalCode} - 	${salesman?.entity?.name}`,
				policy?.endDate,
				getInsuranceType(policy),
				policy?.issuerNumber,
				policy?.contractHolder?.name,
				getInsuredAmountCurrency(policy),
				"", //TODO: Insured Amount
				policy?.premium?.amount,
				policy?.startDate ? formatDate(policy?.startDate) : "",
				policy?.endDate ? formatDate(policy?.endDate) : "",
				getPolicyOfferNumber(policy?.issuerNumber, payload)
			])
		)
	})

	return output
}

/****************** Function for fetching ******************/
const fetchPolicies = async filterPayload => {
	const dateFrom = filterPayload?.issueDate?.after
		? dayjs(filterPayload?.issueDate?.after).format()
		: null
	const dateTo = filterPayload?.issueDate?.before
		? dayjs(filterPayload?.issueDate?.before)
				.add(1, "day")
				.format()
		: null

	const query = gql`
		query fetchPolicies($where: policyWhereInput!) {
			policies(where: $where) {
				list {
					startDate
					endDate
					product {
						productId {
							type
						}
						pricing {
							currencyCode
						}
					}
					issuerNumber
					contractHolder {
						name
					}
					premium {
						originalPrice
						amount
					}
					proposal {
						renewalHistory {
							renewedFrom {
								id
								policies {
									issuerNumber
								}
							}
						}
						basket {
							offerNumber
						}
					}
					commissionSplitRules {
						entity {
							name
							internalCode
						}
						remark
					}
				}
			}

			cases {
				list {
					proposals {
						basket {
							offerNumber
						}
						policies {
							issuerNumber
						}
					}
				}
			}
		}
	`
	const variables = {
		where: {
			and: [
				{ issueDate_gt: dateFrom },
				{ issueDate_lt: dateTo },
				{ status_in: ["ISSUED"] }
			]
		}
	}

	const res = await api({ query, variables })
	//TODO: error handling
	return res?.data?.policies?.list
}

/****************** Export ******************/
export default async filterPayload => {
	const fetchedData = await fetchPolicies(filterPayload)
	const workSheetData = [...header, ...rows(fetchedData)]
	const workSheetColumns = header?.[0]?.map(item => ({ wpx: 200 }))
	return { workSheetData, workSheetColumns }
}
